import { getValidCoordinates } from '@shared/core/places';
import type { SearchParams } from '@shared/utils/accommodations/hotelRoutes';
import type { BuildCarSearchParamsArgs } from '@shared/utils/accommodations/carSearchParams.types';

/** Builds validated query parameters for the `/:eventHandle/car/search` route. */
export const buildCarSearchParams = ({ checkIn, checkOut, destination, utm }: BuildCarSearchParamsArgs): SearchParams => {
  const coordinates = getValidCoordinates(destination);

  return {
    ...utm,
    checkin: checkIn,
    checkout: checkOut,
    destination: destination?.name ?? undefined,
    googlePlaceId: destination?.placeId ?? undefined,
    lat: coordinates ? coordinates.lat.toString() : undefined,
    lng: coordinates ? coordinates.lng.toString() : undefined,
  };
};
